import React, { ReactNode, createContext, useContext, useState } from 'react';

import WrapIf from '../../components/WrapIf/WrapIf';

type CollapsableContextType = {
    collapsed: boolean;
    setCollapsed: (collapsed: boolean) => void;
    disabled: boolean;
};

const CollapsableContext = createContext<CollapsableContextType>({
    collapsed: false,
    setCollapsed: () => {},
    disabled: true,
});

type ProviderOptions = {
    children: ReactNode;
    defaultCollapsed?: boolean;
    onChange?: (collapsed: boolean) => void;
    disabled?: boolean;
};

export const CollapsableProvider = ({
    children,
    onChange,
    defaultCollapsed = false,
    disabled = false,
}: ProviderOptions) => {
    const [collapsed, setCollapsed] = useState(defaultCollapsed || false);

    return (
        <WrapIf
            condition={!disabled}
            wrapper={(children) => {
                return (
                    <CollapsableContext.Provider
                        value={{
                            collapsed: collapsed,
                            setCollapsed: (collapsed: boolean) => {
                                setCollapsed(collapsed);
                                onChange && onChange(collapsed);
                            },
                            disabled: disabled,
                        }}
                    >
                        {children}
                    </CollapsableContext.Provider>
                );
            }}
        >
            {children}
        </WrapIf>
    );
};

export const useCollapsable = () => useContext(CollapsableContext);
